
const layout = {
    namespaced: true,
    state: {
        layoutList: [],
        layoutListTimestamp: null,
        layouts: [],
        layoutInfopoints: [],
        selectedLayout: null,
    },
    mutations: {
        updateLayoutList(state, newList) {
            state.layoutListTimestamp = new Date().getTime();
            state.layoutList = newList;
        },

        updateLayouts(state, newList) {
            state.layouts = newList;
        },
        updateLayoutInfopoints(state, newList) {
            state.layoutInfopoints = newList;
        },
        changeSelectedLayout(state, layout) {
            state.selectedLayout = layout;
        },

    },
    actions: {
        getLayoutList(context) {
          return new Promise((resolve , reject) => {
            try {
                resolve(context.state.layoutList);
                return;
            } catch(err) { 
                console.error(err)
            }

            this._vm.$traveller_http.get('/traveller/restui/infopoint/getLayouts')
              .then(response => {
                  context.commit('updateInfopointList', response.data);
                  resolve(response.data);
                  return;
              }, error => { reject(error); });
          });
        },
        getLayouts(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/getLayouts')
                    .then(response => {
                        context.commit('updateLayouts', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error("Error fetching layouts:", error);
                        reject(error);
                    });
            });
        },
        getLayoutInfopoints(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/getLayoutInfopoints', { params: { "id": id } })
                    .then(response => {
                        context.commit('updateLayoutInfopoints', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error("Error fetching layout infopoints: ", error);
                        reject(error);
                    });
            });
        },
    },
    getters: {
        getLayoutById: (state) => (id) => {
            return state.layoutList.find(layout => layout.id === id);
        }
    }
}

export default layout;
